<style scoped>
</style>

<script>
  import Person from "./person.ts";
  export default Person;
</script>